import React from 'react';

import './captcha_terms.scss';

const CaptchaTerms = ({ signedIn }) => {
  if (signedIn) {
    return null;
  } else {
    return (<div className="captcha-terms">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
    </div>)
  }
}

export default CaptchaTerms;



// WEBPACK FOOTER //
// ./app/javascript/captcha_terms/captcha_terms.js